import React from 'react';

/*
 * The signed-in user's menu, shared from AdminLayout so headlines can name where they are
 * ("Setup · Devices") without every screen hard-coding it. AdminLayout already loads the menu
 * (PCGetUserMenu.php) for the sidebar; it provides the same `sections` array here:
 *   [{ SECTION: 'Setup', links: [{ MENU_URL: '/admin/system-devices', MENU_TEXT: 'Devices' }] }]
 * Renaming a menu therefore renames every breadcrumb that points at it.
 */
export const MenuContext = React.createContext(null);

/* { section, text } for a path, or null. Trailing slashes and case are ignored. */
export function findCrumb(sections, pathname) {
    if (!Array.isArray(sections) || !pathname) return null;
    const norm = (u) => String(u || '').toLowerCase().replace(/\/+$/, '');
    const here = norm(pathname);
    for (const sec of sections) {
        for (const l of (sec.links || [])) {
            if (norm(l.MENU_URL) === here) return { section: sec.SECTION, text: l.MENU_TEXT };
        }
    }
    return null;
}
